import { debounce } from '@utils/debounce';
import { ListItemManager } from './types';

export const createResizeHandler = (
  mainNavigationSelector: HTMLElement,
  mainList: HTMLElement,
  listItemManager: ListItemManager
) => {
  let lastNavContainerWidth = 0;
  let navWidth = mainList.getBoundingClientRect().width;
  const handleWidthChange = (entries: ResizeObserverEntry[]) => {
    entries.forEach((entry: ResizeObserverEntry) => {
      const newWidth = entry.contentRect.width;
      navWidth = mainList.getBoundingClientRect().width;
      if (newWidth !== lastNavContainerWidth) {
        lastNavContainerWidth = newWidth;
        listItemManager.resetOverflowMenu();
        listItemManager.checkListItemsFit(navWidth);
      }
    });
  };
  const debouncedHandleWidthChange = debounce(handleWidthChange, 20);
  const resizeObserver = new ResizeObserver(debouncedHandleWidthChange);
  return () => {
    if (mainNavigationSelector.offsetWidth > 0 || mainNavigationSelector.offsetHeight > 0) {
      resizeObserver.observe(mainNavigationSelector);
    }
  };
};
